// extracted by mini-css-extract-plugin
export default {"loadingState":"ResultHl7Preview_loadingState__vWKHK","loadingSpinner":"ResultHl7Preview_loadingSpinner__+KcIT","spin":"ResultHl7Preview_spin__or3py"};